import { useQuery, queryCache } from 'react-query';
import { KeyResolver } from '../KeyResolver';
const keysFetcher = async (keys, infraApiUrl) => {
  if (!keys) {
    throw new Error('no keys provided');
  }
  const keyResolver = new KeyResolver(infraApiUrl);
  return await keyResolver.getMany(keys);
};
let infraApiUrlRef = '';
const useFetchSecrets = keys => {
  return useQuery(keys.length > 0 && [keys, infraApiUrlRef], keysFetcher, {
    cacheTime: 60 * 60 * 1000,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    onSuccess: data => {
      Object.keys(data).forEach(key => {
        queryCache.setQueryData(key, data[key], {
          cacheTime: Infinity,
          staleTime: Infinity,
          refetchOnMount: false,
          refetchOnWindowFocus: false
        });
      });
    }
  });
};
export const useSecrets = infraApiUrl => {
  infraApiUrlRef = infraApiUrl !== null && infraApiUrl !== void 0 ? infraApiUrl : '';
  return useFetchSecrets;
};